// extracted by mini-css-extract-plugin
export default {"skillBtn":"AddSkill_skillBtn__GcynA","input-skill-label":"AddSkill_input-skill-label__hTuVD","skillBtnSubmit":"AddSkill_skillBtnSubmit__Db+lE","error":"AddSkill_error__D7iNy"};